"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var base_service_1 = require("../base-service");
var alertminer_api_configuration_1 = require("../alertminer-api-configuration");
var operators_1 = require("rxjs/operators");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../alertminer-api-configuration"));
var i2 = __importStar(require("@angular/common/http"));
var InventoryClientService = /** @class */ (function (_super) {
    __extends(InventoryClientService, _super);
    function InventoryClientService(config, http) {
        return _super.call(this, config, http) || this;
    }
    /**
     * @param request undefined
     * @return Success
     */
    InventoryClientService.prototype.InventoryBestMatchToTrimPOSTResponse = function (request) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = request;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/Inventory/InventoryBestMatchToTrim", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param request undefined
     * @return Success
     */
    InventoryClientService.prototype.InventoryBestMatchToTrimPOST = function (request) {
        return this.InventoryBestMatchToTrimPOSTResponse(request).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param request undefined
     * @return Success
     */
    InventoryClientService.prototype.InventoryBestMatchPOSTResponse = function (request) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = request;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/Inventory/InventoryBestMatch", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param request undefined
     * @return Success
     */
    InventoryClientService.prototype.InventoryBestMatchPOST = function (request) {
        return this.InventoryBestMatchPOSTResponse(request).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `InventoryClientService.InventoryRecommendationUsedCarByEntityidGETParams` containing the following parameters:
     *
     * - `entityId`:
     *
     * - `saleType`:
     *
     * - `currentTerm`:
     *
     * - `currentPayment`:
     *
     * @return Success
     */
    InventoryClientService.prototype.InventoryRecommendationUsedCarByEntityidGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        if (params.saleType != null)
            __params = __params.set('saleType', params.saleType.toString());
        if (params.currentTerm != null)
            __params = __params.set('currentTerm', params.currentTerm.toString());
        if (params.currentPayment != null)
            __params = __params.set('currentPayment', params.currentPayment.toString());
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/Inventory/InventoryRecommendation_UsedCar/" + params.entityId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `InventoryClientService.InventoryRecommendationUsedCarByEntityidGETParams` containing the following parameters:
     *
     * - `entityId`:
     *
     * - `saleType`:
     *
     * - `currentTerm`:
     *
     * - `currentPayment`:
     *
     * @return Success
     */
    InventoryClientService.prototype.InventoryRecommendationUsedCarByEntityidGET = function (params) {
        return this.InventoryRecommendationUsedCarByEntityidGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param request undefined
     * @return Success
     */
    InventoryClientService.prototype.InventoryRecommendationNewCarPOSTResponse = function (request) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = request;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/Inventory/InventoryRecommendation_NewCar", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param request undefined
     * @return Success
     */
    InventoryClientService.prototype.InventoryRecommendationNewCarPOST = function (request) {
        return this.InventoryRecommendationNewCarPOSTResponse(request).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    InventoryClientService.prototype.GetStockViewByDealeridGETResponse = function (dealerId) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/Inventory/GetStockView/" + dealerId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    InventoryClientService.prototype.GetStockViewByDealeridGET = function (dealerId) {
        return this.GetStockViewByDealeridGETResponse(dealerId).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    InventoryClientService.prototype.GetStockViewsGETResponse = function (dealerId) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        (dealerId || []).forEach(function (val) { if (val != null)
            __params = __params.append('dealerId', val.toString()); });
        var req = new http_1.HttpRequest('GET', this.rootUrl + "/api/Inventory/GetStockView", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    InventoryClientService.prototype.GetStockViewsGET = function (dealerId) {
        return this.GetStockViewsGETResponse(dealerId).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `InventoryClientService.GetExtByStockNoByStocknoByEntityidByPricingplanidGETParams` containing the following parameters:
     *
     * - `stockNo`:
     *
     * - `pricingPlanID`:
     *
     * - `entityId`:
     *
     * @return Success
     */
    InventoryClientService.prototype.GetExtByStockNoByStocknoByEntityidByPricingplanidGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/Inventory/GetExtByStockNo/" + params.stockNo + "/" + params.entityId + "/" + params.pricingPlanID), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `InventoryClientService.GetExtByStockNoByStocknoByEntityidByPricingplanidGETParams` containing the following parameters:
     *
     * - `stockNo`:
     *
     * - `pricingPlanID`:
     *
     * - `entityId`:
     *
     * @return Success
     */
    InventoryClientService.prototype.GetExtByStockNoByStocknoByEntityidByPricingplanidGET = function (params) {
        return this.GetExtByStockNoByStocknoByEntityidByPricingplanidGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `InventoryClientService.GetInventoryOpportunitiesByDealeridByStocknumberByCashadjustmentGETParams` containing the following parameters:
     *
     * - `stockNumber`:
     *
     * - `dealerId`:
     *
     * - `cashAdjustment`:
     *
     * @return Success
     */
    InventoryClientService.prototype.GetInventoryOpportunitiesByDealeridByStocknumberByCashadjustmentGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/Inventory/GetInventoryOpportunities/" + params.dealerId + "/" + params.stockNumber + "/" + params.cashAdjustment), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `InventoryClientService.GetInventoryOpportunitiesByDealeridByStocknumberByCashadjustmentGETParams` containing the following parameters:
     *
     * - `stockNumber`:
     *
     * - `dealerId`:
     *
     * - `cashAdjustment`:
     *
     * @return Success
     */
    InventoryClientService.prototype.GetInventoryOpportunitiesByDealeridByStocknumberByCashadjustmentGET = function (params) {
        return this.GetInventoryOpportunitiesByDealeridByStocknumberByCashadjustmentGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param request undefined
     * @return Success
     */
    InventoryClientService.prototype.SearchPOSTResponse = function (request) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = request;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/Inventory/Search", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param request undefined
     * @return Success
     */
    InventoryClientService.prototype.SearchPOST = function (request) {
        return this.SearchPOSTResponse(request).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    InventoryClientService.InventoryBestMatchToTrimPOSTPath = '/api/Inventory/InventoryBestMatchToTrim';
    InventoryClientService.InventoryBestMatchPOSTPath = '/api/Inventory/InventoryBestMatch';
    InventoryClientService.InventoryRecommendationUsedCarByEntityidGETPath = '/api/Inventory/InventoryRecommendation_UsedCar/{entityId}';
    InventoryClientService.InventoryRecommendationNewCarPOSTPath = '/api/Inventory/InventoryRecommendation_NewCar';
    InventoryClientService.GetStockViewByDealeridGETPath = '/api/Inventory/GetStockView/{dealerId}';
    InventoryClientService.GetStockViewsGETPath = '/api/Inventory/GetStockView';
    InventoryClientService.GetExtByStockNoByStocknoByEntityidByPricingplanidGETPath = '/api/Inventory/GetExtByStockNo/{stockNo}/{entityId}/{pricingPlanID}';
    InventoryClientService.GetInventoryOpportunitiesByDealeridByStocknumberByCashadjustmentGETPath = '/api/Inventory/GetInventoryOpportunities/{dealerId}/{stockNumber}/{cashAdjustment}';
    InventoryClientService.SearchPOSTPath = '/api/Inventory/Search';
    InventoryClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InventoryClientService_Factory() { return new InventoryClientService(i0.ɵɵinject(i1.AlertminerApiConfiguration), i0.ɵɵinject(i2.HttpClient)); }, token: InventoryClientService, providedIn: "root" });
    return InventoryClientService;
}(base_service_1.BaseService));
exports.InventoryClientService = InventoryClientService;
